import { InjectionToken, inject } from '@angular/core';
import { SessionManagerService } from './session-manager.service';

/**
 * What `SessionWarningDialogComponent` needs from whichever session owns the
 * current screen. The root default is the ICS `SessionManagerService`; the OHAH
 * portal shell overrides it with its own source so the same dialog can warn
 * about the OHAH session without touching the ICS singletons.
 */
export interface SessionWarningSource {
  isRefreshing: () => boolean;
  showSessionWarning: () => boolean;
  timeRemainingDisplay: () => string;
  progressPercent: () => number;
  extendSession(): void | Promise<void>;
  logout(): void;
}

export const SESSION_WARNING_SOURCE = new InjectionToken<SessionWarningSource>(
  'SESSION_WARNING_SOURCE',
  {
    providedIn: 'root',
    factory: () => inject(SessionManagerService),
  },
);
